import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from './Layout';
import AuthGuard from './AuthGuard';
import AdminRoute from '../shared/auth/AdminRoute';
import SignedOutPage from './SignedOutPage';
import DevicesPage from '../features/weighing/DevicesPage';
import RegisterBindingsPage from '../features/weighing/RegisterBindingsPage';
import KioskPage from '../features/weighing/kiosk/KioskPage';
import WeighingRequestsPage from '../features/weighing/WeighingRequestsPage';
import PalletRegistrationsPage from '../features/pallet-registrations/PalletRegistrationsPage';
import TpnBookingsPage from '../features/tpn-bookings/TpnBookingsPage';
import TpnVehiclesPage from '../features/tpn-vehicles/TpnVehiclesPage';
import UserDetailPage from '../features/user-detail/UserDetailPage';
import WeighingSubmitPage from '../features/weighing/WeighingSubmitPage';

function AuthenticatedRoutes() {
  return (
    <AuthGuard>
      <Routes>
        <Route element={<Layout />}>
          <Route index element={<KioskPage />} />
          <Route path="kiosk" element={<KioskPage />} />
          <Route path="weighing-requests" element={<WeighingRequestsPage />} />
          <Route path="devices" element={<AdminRoute><DevicesPage /></AdminRoute>} />
          <Route path="register-bindings" element={<AdminRoute><RegisterBindingsPage /></AdminRoute>} />
          <Route path="pallet-registrations" element={<PalletRegistrationsPage />} />
          <Route path="tpn-bookings" element={<TpnBookingsPage />} />
          <Route path="tpn-vehicles" element={<AdminRoute><TpnVehiclesPage /></AdminRoute>} />
          <Route path="user-detail" element={<UserDetailPage />} />
          <Route path="weighing-submit" element={<AdminRoute><WeighingSubmitPage /></AdminRoute>} />
        </Route>
      </Routes>
    </AuthGuard>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="signed-out" element={<SignedOutPage />} />
        <Route path="*" element={<AuthenticatedRoutes />} />
      </Routes>
    </BrowserRouter>
  );
}
